import { RestClient } from '@/api/rest-client'
import { RealworksProduct } from '@/api/model/realworks-product'

export class RealworksProductClient extends RestClient<RealworksProduct> {
    collectionName = 'service/realworks/product'
    parseData = RealworksProduct.fromData
}
